import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './Index.css';
import './static/Assets/css/style.css';
import './App.less';
import registerServiceWorker from './registerServiceWorker';
import { Provider } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import { store } from './Store/store';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';

ReactDOM.render(
  <Provider store={store}>
    <div>
      <App />  
      <ReduxToastr
        timeOut={4000}
        newestOnTop={false}
        preventDuplicates
        position="top-left"
        getState={(state) => state.toastr} // This is the default
        transitionIn="fadeIn"
        transitionOut="fadeOut"
        progressBar
        closeOnToastrClick/>
    </div>
  </Provider>,
  document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js